<template>
  <!-- Carousel -->
    <div id="slider">
      <b-carousel
        id="carousel-fade"
        indicators 
        class="d-none d-lg-block"
      >
        <b-carousel-slide
          :img-src="images.banner1"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner2"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner3"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner4"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner5"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner6"
        >
        </b-carousel-slide>
      </b-carousel>


      <b-carousel
        id="carousel-fade"
        indicators 
        class="d-lg-none"
      >
        <b-carousel-slide
          :img-src="images.banner1sm"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner2sm"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner3sm"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner4sm"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner5sm"
        >
        </b-carousel-slide>
        <b-carousel-slide
          :img-src="images.banner6sm"
        >
        </b-carousel-slide>
      </b-carousel>



        <!-- Sign Up Button -->
        <div id="signupbtn">
          <cq-btn centerfloatbtn="true">SIGN UP FOR A FREE DEMO</cq-btn>
        </div>
        <!-- End Sign Up Button -->
    </div>
    <!-- End Carousel -->
</template>

<script>
import CQButton from '@/components/ui/CQButton.vue'

// Import Images
import banner1 from '@/assets/image/home/banner1.png'
import banner2 from '@/assets/image/home/banner2.jpg'
import banner3 from '@/assets/image/home/banner3.jpg'
import banner4 from '@/assets/image/home/banner4.jpg'
import banner5 from '@/assets/image/home/banner5.jpg'
import banner6 from '@/assets/image/home/banner6.jpg'

// Import Images for small screen
import banner1sm from '../../assets/image/home/smallscreen/banner1-sm.jpg'
import banner2sm from '../../assets/image/home/smallscreen/banner2-sm.jpg'
import banner3sm from '../../assets/image/home/smallscreen/banner3-sm.jpg'
import banner4sm from '../../assets/image/home/smallscreen/banner4-sm.jpg'
import banner5sm from '../../assets/image/home/smallscreen/banner5-sm.jpg'
import banner6sm from '../../assets/image/home/smallscreen/banner6-sm.jpg'


export default {
  components: {
    'cq-btn' : CQButton,
  },
  data() {
    return {
      images: {
        banner1,
        banner2,
        banner3,
        banner4,
        banner5,
        banner6,
        banner1sm,
        banner2sm,
        banner3sm,
        banner4sm,
        banner5sm,
        banner6sm
      }
    }
  }
}
</script>

<style scoped>
#slider >>> div.carousel-caption{
  text-align: left;
}

#slider >>> .carousel-indicators li {
  width: 18px !important;
  height: 18px !important;
  border-radius: 50%; 
  opacity: 1 !important;
  background-color: grey !important;
}

#slider >>> .carousel-indicators{
  position: relative !important;
  justify-content: flex-start !important;
  bottom: 20px !important;
  left: -30px !important;
}

#slider >>> .carousel-indicators .active {
  background-color: var(--primary-color) !important;
}

/* Mobile View */
@media only screen and (max-width: 992px){
  #slider >>> .carousel-indicators li {
    width: 16px !important;
    height: 17px !important;
  }

  #slider >>> #signupbtn{
    display: flex;
    justify-content: center;
  }

  #slider >>> #signupbtn .cq-btn{
    padding-top: 0 !important;
  }
}

/* Desktop View */
@media only screen and (min-width: 992px){
  #slider >>> #signupbtn{
    z-index: 1; 
    position: relative;
    margin-top: -100px;
    float: right;
    right: 150px !important;
  }
}

</style>